<template>
  <div class="flex aic" v-if="total > pageSize">
    <div class="flex aic jcc page-box w100">
      <page class="df-page" v-on="$listeners" v-bind="$props" ref="page" @on-change="changePage($event,'curr')" @on-page-size-change="changePage($event,'limits')" ></page>
      <p class="pl20 pr10">跳至</p>
      <input class="curr-input tac" type="text" v-model="currPage" @input="changeInput" />
      <p class="pl10">页</p>
      <div class="csp define" @click="changeCurr">确定</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DfPage",
  props: {
    showTotal: {
      type: Boolean,
      default: true,
    },
    showElevator: {
      type: Boolean,
      default: false,
    },
    showSizer: {
      type: Boolean,
      default: false,
    },
    total: {
      type: Number | String,
      default: 0,
    },
    current: {
      type: Number | String,
      default: 1,
    },
    pageSize: {
      type: Number | String,
      default: 10,
    },
    pageSizeOpts: {
      type: Array,
      default () {
        return [10, 20, 30, 40];
      },
    },
  },
  data () {
    return {
      currPage: '',
    }
  },
  methods: {
    // 改变页码和页数事件
    changePage (value, prop) {
      this.$emit('change', +value, prop);
      this.currPage = '';
    },
    // 限制输入的页数
    changeInput(){
      this.currPage = this.currPage.replace(/\D|^0/g,'');
      let pages = Math.ceil((+this.total / +this.pageSize));
      if(+this.currPage > pages){
        this.currPage = pages;
      }
    },
    // 电梯事件
    changeCurr () {
      if(!this.currPage) return;
      if(+this.currPage === +this.current) return;
      this.changePage(this.currPage,'curr');
    }
  }
}
</script>

<style lang="less" scoped>
.define {
  padding-left: 17px;
  &:hover {
    color: #2d8cf0;
  }
}
.page-box {
  padding-bottom: 64px;
}

  
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button{
  -webkit-appearance: none;
}
.curr-input{
  width: 60px;
  border: 1px solid #dcdee2;
  border-radius: 4px;
  height: 32px;
  line-height: 30px;
}
</style>